:host {
  display: contents;
}

.spw-card-subtags {
  // display: flex;
  margin-bottom: 8px;
  color: var(--spw-ds-primary);
  spw-card-subtag-item,
  .spw-card-subtag-item {
    &:after {
      content: ',';
      margin-right: 2px;
      display: inline;
    }
    &:last-child {
      &:after {
        display: none;
      }
    }
  }
}
